<template>
  <input
    v-model="inputValue"
    v-mask="'+# (###) ###-##-##'"
    autocomplete="tel"
    class="input"
    placeholder="+ 7 ( ... ) ... .. .."
    @focus="setStartValue"
    @blur="unsetStartValue"
  />
</template>
<script>
import { VueMaskDirective } from 'v-mask';
export default {
  name: 'PhoneInput',
  directives: { mask: VueMaskDirective },
  props: {
    placeholder: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('changedValue', newValue);
      }
    }
  },
  methods: {
    setStartValue() {
      this.$emit('changedValue', this.value === '' ? '+' : this.value);
      this.$emit('focus');
    },
    unsetStartValue() {
      this.$emit('changedValue', this.value === '+' ? '' : this.value);
      this.$emit('blur');
    }
  }
};
</script>

<style lang="scss" scoped>
input::placeholder {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.3px;
  color: #76767b;
}
input {
  padding: 16px 13px 14px;
  width: 100%;
  border: none;
  background: transparent;
}
</style>
